<template>
  <b-navbar :spaced="false" :shadow="true">
    <template slot="brand">
      <b-navbar-item tag="a" href="https://hublogiq.nl/" target="_blank" rel="noopener">
        <img src="../assets/images/company_logo.png"
          alt="HubLogiQ: integreert de kracht van IoT en Assets Management in een Alles-in-1 platform." width="112"
          height="28" />
      </b-navbar-item>
    </template>

    <template slot="start">
      <b-navbar-item v-if="showLinks" tag="router-link" :to="{ path: '/' }">
        {{ $t("navbar.reportsHeader") }}
      </b-navbar-item>

      <b-navbar-item v-if="showLinks" tag="router-link" :to="{ name: 'notifications' }">
        {{ $t("navbar.notificationsHeader") }}
      </b-navbar-item>

      <b-navbar-item v-if="showLinks" tag="router-link" :to="{ name: 'settings' }">
        {{ $t("navbar.settingsHeader") }}
      </b-navbar-item>

      <b-navbar-item v-if="showLinks && showAdminLink" tag="router-link" :to="{ name: 'admin' }">
        {{ $t("navbar.adminHeader") }}
      </b-navbar-item>

      <b-navbar-item tag="a" v-if="showLinks" href="https://trips-docs.ashita.nl/" target="_blank" rel="noopener">
        {{ $t("navbar.documentationHeader") }}
      </b-navbar-item>
    </template>

    <template slot="end">
      <language-dropdown />

      <b-navbar-item tag="div" v-if="showLogout">
        <div class="buttons">
          <b-button @click="logout" type="is-danger">
            {{ $t("navbar.logout") }}
          </b-button>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>

import LanguageDropdown from "@/components/misc/LanguageDropdown";

export default {
  name: "Navbar",
  components: {
    LanguageDropdown
  },
  methods: {
    logout() {
      this.$emit('logout');
    }
  },
  props: {
    loginActive: {
      type: Boolean,
      required: true
    },
    showLinks: {
      type: Boolean,
      default: false
    },
    showLogout: {
      type: Boolean,
      default: true
    },
    showAdminLink: {
      type: Boolean,
      default: false
    }
  }
};

</script>

<style scoped></style>